import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BookingPaymentState } from "./types";
import { IBooking } from "@/shared/api/aviabooking";

const initialState: BookingPaymentState = {
    isPaymentModalOpen: false,
    onPayment: null,

    isCancelBookingModalOpen: false,
    onCancel: null,

    isTicketsModalOpen: false,

    isAcknowledgeModalOpen: false,
    onAcknowledge: null,

    booking: {
        status: 1,
        booking_id: "",
        created_at: new Date(0).toISOString(),
        segments: [],
        price_summary: {
            taxes: 0,
            total_fare: 0,
            currency: ""
        },
        travellers: [],
        price_changed: false,
        price_prev: 0,
        order_status: 0
    }
}

interface OpenPaymentModal {
    booking: IBooking
    onPayment?: () => void
}

interface OpenCancelBookingModal {
    booking: IBooking
    onCancel?: () => void
}

interface OpenTicketsModal {
    booking: IBooking
}

interface OpenAcknowledgeModal {
    booking: IBooking
    onAcknowledge?: () => void
}

const bookingPaymentSlice = createSlice({
    name: 'bookingPayment',
    initialState,
    reducers: {
        openPaymentModal: (state, action: PayloadAction<OpenPaymentModal>) => {
            state.isPaymentModalOpen = true
            state.onPayment = action.payload.onPayment
            state.booking = action.payload.booking
        },
        closePaymentModal: (state) => {
            state.isPaymentModalOpen = false
        },
        openCancelBookingModal: (state, action: PayloadAction<OpenCancelBookingModal>) => {
            state.isCancelBookingModalOpen = true
            state.onCancel = action.payload.onCancel
            state.booking = action.payload.booking
        },
        closeCancelBookingModal: (state) => {
            state.isCancelBookingModalOpen = false
        },
        openTicketsModal: (state, action: PayloadAction<OpenTicketsModal>) => {
            state.isTicketsModalOpen = true
            state.booking = action.payload.booking
        },
        closeTicketsModal: (state) => {
            state.isTicketsModalOpen = false
        },
        openAcknowledgeModal: (state, action: PayloadAction<OpenAcknowledgeModal>) => {
            state.isAcknowledgeModalOpen = true
            state.onAcknowledge = action.payload.onAcknowledge
            state.booking = action.payload.booking
        },
        closeAcknowledgeModal: (state) => {
            state.isAcknowledgeModalOpen = false
        }
    }
})

export default bookingPaymentSlice.reducer
export const {
    openPaymentModal,
    closePaymentModal,
    openCancelBookingModal, 
    closeCancelBookingModal,
    closeTicketsModal,
    openTicketsModal,
    openAcknowledgeModal,
    closeAcknowledgeModal
} = bookingPaymentSlice.actions